import React, {useContext} from 'react'
import {Box, Container, Grid, Typography} from '@mui/material'
import ProgressBar from './components/ProgressBar'
import Copyright from './components/Copyright'
import {Outlet} from 'react-router-dom'
import {OrgCustomizationContext} from "./themes/OrgCustomizationProvider";
import LanguageSelector from "./components/LanguageSelector";

const HUD = () => {
    const {orgName, t} = useContext(OrgCustomizationContext)
    
    return (
        <Container maxWidth='lg'>
            <Grid container spacing={3}>
                <Grid container item>
                    <Grid item xs={10}>
                        <Typography
                            variant='h4'
                            color='primary'
                            style={{marginBottom: 10, marginTop: 30}}
                        >
                            {orgName} {t('gi_complaints')}
                        </Typography>
                    </Grid>

                    <Grid item xs={2}>
                        <Box display='flex' justifyContent='flex-end' alignItems='center' sx={{height: '100%'}}>
                            <LanguageSelector/>
                        </Box>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <ProgressBar/>
                    <Outlet/>
                </Grid>
            </Grid>

            <Grid item xs={12}>
                <Copyright/>
            </Grid>
        </Container>
    )
}

export default HUD
